export default __webpack_public_path__ + "static/media/icon-arrow-white.649b132c.svg";